import { render, staticRenderFns } from "./getInsinfoaView.vue?vue&type=template&id=3f56984d&scoped=true&"
import script from "./getInsinfoaView.vue?vue&type=script&lang=js&"
export * from "./getInsinfoaView.vue?vue&type=script&lang=js&"
import style0 from "./getInsinfoaView.vue?vue&type=style&index=0&id=3f56984d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56984d",
  null
  
)

export default component.exports